import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { Matrix } from "../matrix/index";
import { TarifaCell } from "./cell";
import { firstMap } from "keautils";
export interface Props {
    distancias: models.MatrizTarifaDistancia[];
    pesos: models.MatrizTarifaPeso[];
    value: models.MatrizTarifaCelda[];
    onChange: (value: models.MatrizTarifaCelda[]) => PromiseLike<void>;
}


/**Obtiene el nuevo valor del control dado un cambio en una celda */
function changeCell(oldValue: models.MatrizTarifaCelda[], columna: number, fila: number, value: number): models.MatrizTarifaCelda[] {
    const oldValueCell = oldValue.filter(x => x.FilaDistancia == fila && x.ColumnaPeso == columna)[0];
    const newCell = { Tarifa: value, FilaDistancia: fila, ColumnaPeso: columna } as models.MatrizTarifaCelda;
    if (oldValueCell == null) {
        //No existe en la lista, lo agregamos:
        return [...oldValue, newCell];
    } else {
        //Lo sustituimos:
        return oldValue.map((x, i) => x == oldValueCell ? newCell : x);
    }
}

/**Obtiene el valor de una celda */
function getCellValue(value: models.MatrizTarifaCelda[], columna: number, fila: number) {
    const valueCell = value.filter(x => x.FilaDistancia == fila && x.ColumnaPeso == columna)[0];
    return valueCell && valueCell.Tarifa || 0;
}

/**
* Componente para editar los valores de la tarifa
*/
export class TarifaValores extends React.PureComponent<Props> {
    private handleOnChange = (value: number, columna: number, fila: number) => {
        this.props.onChange(changeCell(this.props.value, columna, fila, value));
    };

    render() {
        const { value, distancias, pesos } = this.props;

        const rows = distancias.map(x => x.DistanciaHasta).map((x, i, arr) => `${(arr[i - 1] || 0)} < D <= ${x}`);
        const columns3 = pesos.map(x => x.PesoHasta ).map((x, i, arr) => `${(arr[i - 1] || 0)} < P <= ${x}`);
        
        const columns = pesos.map((x , i, arr) => `${( i > 0 ?  arr[i - 1].PesoHasta : 0 )} < P <= ${x.PesoHasta}` + '   ' +`${( i > 0 ?  arr[i - 1].CubicaionHasta : 0 )} < m3 <= ${x.CubicaionHasta}` );
        
        const cells = distancias.map((dis, iDis) => pesos.map((peso, iPeso) => {
            const cellValue = getCellValue(this.props.value, iPeso, iDis);
            return <TarifaCell value={cellValue} onChange={x => this.handleOnChange(x, iPeso, iDis)} />;
        }));

        return (
            <div>
                <div className="alert alert-info">
                    <ul>
                        <li>
                            Los pesos (kg) estan en las columnas y las distancias (km) en las filas
                    </li>
                        <li>
                            Los rangos son exclusivos del lado inferior e inclusivos del lado superior
                        </li>
                    </ul>
                </div>
                <Matrix
                    rows={rows}
                    columns={columns}
                    cells={cells}
                />
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/componentes/valores/index.tsx